import { useSelector } from 'react-redux';
import { selectFeatureFlagData } from 'store/featureFlag/featureFlagSelector';

const useFeatureFlag = () => {
    const {
        clientEquipmentEnabled: isClientEquipmentEnabled,
        clientRequestEnabled: isClientRequestEnabled,
        ssoenabled: isSsoEnabled,
        inventoryEnabled: isInventoryEnabled,
        yardCheckEnabled: isYardCheckEnabled,
        dynamicFormsEnabled: isDynamicFormsEnabled,
        dynamicFormsEnabledActiveObjectIds: dynamicFormsEnabledActiveObjectIds,
        userPermissionEnabled: isUserPermissionEnabled,
        userPermissionDataRestrictionEnabled: isUserPermissionDataRestrictionEnabled,
        keycloakIntegrationEnabled: isKeycloakIntegrationEnabled,
    } = useSelector(selectFeatureFlagData) ?? {};

    return {
        isClientEquipmentEnabled,
        isSsoEnabled,
        isClientRequestEnabled,
        isInventoryEnabled,
        isYardCheckEnabled,
        isDynamicFormsEnabled,
        dynamicFormsEnabledActiveObjectIds,
        isUserPermissionEnabled,
        isUserPermissionDataRestrictionEnabled,
        isKeycloakIntegrationEnabled,
    };
};

export default useFeatureFlag;
